import React from 'react';
import { useTranslation } from 'react-i18next';

const ProductUpdateCard = ({ update, onEdit, onDelete }) => {
  const { t } = useTranslation();
  
  // Debug log to see what data we're receiving
  console.log('Update data:', update);

  const formatDate = (timestamp) => {
    try {
      // Convert milliseconds to Date object
      const date = new Date(Number(timestamp));
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid Date';
    }
  };

  if (!update) {
    return null;
  }

  return (
    <div className="bg-[#2A3C29] p-6 rounded-lg">
      <div className="flex justify-between items-start mb-4">
        <div>
          <h3 className="text-lg font-semibold text-[#E8FC8B]">
            {update.title || 'No Title'}
          </h3>
          <span className="text-sm text-[#ABCDDF] capitalize">
            {update.type || 'live'}
          </span>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(update)}
            className="text-blue-400 hover:text-blue-300"
          >
            {t('edit')}
          </button>
          <button
            onClick={() => onDelete(update._id)}
            className="text-red-400 hover:text-red-300"
          >
            {t('delete')}
          </button>
        </div>
      </div>
      {update.description && (
        <p className="text-[#ABCDDF] mb-4">{update.description}</p>
      )}
      <div className="text-sm text-[#ABCDDF]">
        {t('created')}: {formatDate(update._id)}
      </div>
    </div>
  );
};

export default ProductUpdateCard; 